type MarketplaceShareResult = "SHARED" | "COPIED" | "CANCELLED" | "UNAVAILABLE";

export async function shareMarketplaceListing({
  title,
  url,
}: {
  readonly title: string;
  readonly url: string;
}): Promise<MarketplaceShareResult> {
  if (typeof navigator.share === "function") {
    try {
      await navigator.share({ title, url });
      return "SHARED";
    } catch (error: unknown) {
      if (error instanceof DOMException && error.name === "AbortError")
        return "CANCELLED";
    }
  }

  if (navigator.clipboard === undefined) return "UNAVAILABLE";
  try {
    await navigator.clipboard.writeText(url);
    return "COPIED";
  } catch {
    return "UNAVAILABLE";
  }
}
